import {
  AxisStructuredDataIndustry,
  AxisStructuredDataSubIndustry,
  AxisStructuredDataTypeEnum,
} from '../../gql/graphql';
import {
  CLIENT_TYPE_OPTIONS,
  COMMERCIAL_INDUSTRY_OPTIONS,
  LWB_INDUSTRY_OPTIONS,
  PERSONAL_INDUSTRY_OPTIONS,
  PROFESSIONAL_FINANCIAL_SUB_INDUSTRY_OPTIONS,
  CONTRACTOR_SUB_INDUSTRY_OPTIONS,
} from './axisNewClientConstants';
import { AXIS_INQUIRY_OPTIONS } from './axisStructuredDataConstants';

const buildLabelMap = <OptionId extends string>(
  options: Array<{ id: OptionId; label: string }>,
): Partial<Record<OptionId, string>> => {
  return options.reduce<Partial<Record<OptionId, string>>>(
    (acc, option) => {
      acc[option.id] = option.label;
      return acc;
    },
    {},
  );
};

const buildInquiryTypeLabels = (): Partial<
  Record<AxisStructuredDataTypeEnum, string>
> => {
  return AXIS_INQUIRY_OPTIONS.reduce<
    Partial<Record<AxisStructuredDataTypeEnum, string>>
  >((acc, option) => {
    if (option.structuredData.type) {
      acc[option.structuredData.type] = option.label;
    }
    return acc;
  }, {});
};

const AXIS_TYPE_LABELS: Partial<Record<AxisStructuredDataTypeEnum, string>> = {
  ...buildLabelMap(CLIENT_TYPE_OPTIONS),
  ...buildInquiryTypeLabels(),
};

const AXIS_INDUSTRY_LABELS: Partial<Record<AxisStructuredDataIndustry, string>> =
  {
    ...buildLabelMap(PERSONAL_INDUSTRY_OPTIONS),
    ...buildLabelMap(LWB_INDUSTRY_OPTIONS),
    ...buildLabelMap(COMMERCIAL_INDUSTRY_OPTIONS),
  };

const AXIS_SUB_INDUSTRY_LABELS: Partial<
  Record<AxisStructuredDataSubIndustry, string>
> = {
  ...buildLabelMap(CONTRACTOR_SUB_INDUSTRY_OPTIONS),
  ...buildLabelMap(PROFESSIONAL_FINANCIAL_SUB_INDUSTRY_OPTIONS),
};

export const getAxisStructuredDataTypeLabel = (
  type: AxisStructuredDataTypeEnum | null | undefined,
): string | null => {
  if (!type) {
    return null;
  }
  return AXIS_TYPE_LABELS[type] ?? null;
};

export const getAxisStructuredDataIndustryLabel = (
  industry: AxisStructuredDataIndustry | null | undefined,
): string | null => {
  if (!industry) {
    return null;
  }
  return AXIS_INDUSTRY_LABELS[industry] ?? null;
};

export const getAxisStructuredDataSubIndustryLabel = (
  subIndustry: AxisStructuredDataSubIndustry | null | undefined,
): string | null => {
  if (!subIndustry) {
    return null;
  }
  return AXIS_SUB_INDUSTRY_LABELS[subIndustry] ?? null;
};
